var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52609",
    "data-name": "Group 52609",
    transform: "translate(-30 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1623",
    "data-name": "Rectangle 1623",
    transform: "translate(30 29)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_5_",
    "data-name": "svgexport-7 (5)",
    transform: "translate(44.539 43.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52539",
    "data-name": "Group 52539",
    transform: "translate(0 0.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90982",
    "data-name": "Path 90982",
    d: "M5.534,386.186A5.041,5.041,0,0,0,.49,391.23v6.878a1.605,1.605,0,0,0,3.211,0v-1.834H7.368v1.834a1.605,1.605,0,0,0,3.211,0V391.23A5.041,5.041,0,0,0,5.534,386.186Zm1.834,6.878H3.7V391.23a1.834,1.834,0,0,1,3.667,0Z",
    transform: "translate(-0.438 -344.915)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90983",
    "data-name": "Path 90983",
    d: "M126.677,396.588h-1.834v-8.711a1.605,1.605,0,0,0-3.211,0v10.317a1.605,1.605,0,0,0,1.605,1.605h3.439A1.605,1.605,0,0,0,126.677,396.588Z",
    transform: "translate(-87.874 -351.001) rotate(3)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90984",
    "data-name": "Path 90984",
    d: "M207.01,396.588h-1.834v-8.711a1.605,1.605,0,0,0-3.211,0v10.317a1.605,1.605,0,0,0,1.605,1.605h3.439A1.605,1.605,0,0,0,207.01,396.588Z",
    transform: "translate(-180.352 -345.001)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90985",
    "data-name": "Path 90985",
    d: "M47.925,46.153C64.159,26.492,49.992.894,27.45.55,8.9.218-4.835,19.742,1.615,37.081a1.605,1.605,0,0,0,1.513,1.07H10.6a1.605,1.605,0,0,0,1.429-2.336C6.1,24.557,14.713,10.48,27.45,10.639,41.949,10.52,50.123,27.96,40.772,39l-2.928-2.929a1.605,1.605,0,0,0-2.707.808L31.7,53.413a1.61,1.61,0,0,0,1.9,1.9l16.533-3.439a1.605,1.605,0,0,0,.808-2.707Z",
    transform: "translate(0 -0.546)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTest);
export default __webpack_public_path__ + "static/media/AllTest.8a1a1df4ef57b8257998aa4e0a30b858.svg";
export { ForwardRef as ReactComponent };